import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export type AppInstallBannerStatus = 'pending' | 'visible' | 'gone';

export interface AppInstallBannerState {
	status: AppInstallBannerStatus;
}

const initialState: AppInstallBannerState = {
	status: 'pending',
};

export const appInstallBannerSlice = createSlice({
	name: 'appInstallBanner',
	initialState,
	reducers: {
		setAppInstallBannerStatus(state, action: PayloadAction<AppInstallBannerStatus>) {
			state.status = action.payload;
		},
	},
});

export const { setAppInstallBannerStatus } = appInstallBannerSlice.actions;

export const useIsAppInstallBannerGoneSelector = () =>
	useSelector(
		(state: { appInstallBanner: AppInstallBannerState }) => state.appInstallBanner.status === 'gone'
	);
